import * as React from "react";
import { forwardRef } from "react";
const AlipayIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#00A1E9",
  d: "M12.1261 8C9.29259 8 7 10.2944 7 13.1274v21.7463C7 37.704 9.29259 40 12.1261 40h21.749C36.7063 40 39 37.7043 39 34.8737v-.2227c-.0951-.0395-8.3165-3.4686-12.495-5.478-2.8192 3.4692-6.4553 5.5739-10.2307 5.5739-6.3839 0-8.55209-5.5871-5.5293-9.2652.6593-.8017 1.7801-1.5679 3.5205-1.9965 2.7223-.6687 7.0545.4176 11.1147 1.7576.7306-1.3454 1.3448-2.8273 1.8026-4.405h-12.513v-1.267h6.4523v-2.2727h-7.8148V16.03h7.8148v-3.2415s0-.5461.5534-.5461h3.154V16.03h7.7256v1.2681h-7.7256v2.2723h6.3061c-.6035 2.472-1.5195 4.7478-2.6696 6.7451 1.914.6923 3.6321 1.3489 4.9123 1.7777 4.2706 1.4292 5.4674 1.6038 5.6217 1.6219V13.1274C39 10.2948 36.7063 8 33.8751 8zm3.5091 17.3377c-.2739.0031-.5493.0184-.8265.0454-.7997.0803-2.3002.4333-3.1211 1.1589-2.45948 2.145-.9874 6.066 3.9904 6.066 2.8939 0 5.785-1.85 8.0563-4.8121-2.9283-1.4289-5.4503-2.4891-8.0991-2.4585z"
}));
const ForwardRef = forwardRef(AlipayIcon);
export { ForwardRef as AlipayIcon };